import { PlusIcon as PlusIconLucide } from "lucide-react";
import { MinusIcon as MinusIconLucide } from "lucide-react";

export const PaddingTopIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.72925 5.5H21.7709" stroke={color} strokeLinecap="round" />
      <rect
        x="9.16675"
        y="9.5"
        width="9.16667"
        height="6"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaddingBottomIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20.9792 19L5.52092 19" stroke={color} strokeLinecap="round" />
      <rect
        x="17.6667"
        y="15"
        width="8.83333"
        height="6"
        transform="rotate(-180 17.6667 15)"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaddingLeftIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <path
        d="M5.72909 19.5L5.72909 5.5"
        stroke={color}
        strokeLinecap="round"
      />
      <rect
        x="10.3125"
        y="16.5"
        width="8"
        height="6.875"
        transform="rotate(-90 10.3125 16.5)"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaddingRightIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <rect
        x="10.3125"
        y="16"
        width="8"
        height="6.875"
        transform="rotate(-90 10.3125 16)"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M21.7708 19V5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const PaddingHorizontalIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <path
        d="M5.72909 19.5L5.72909 5.5"
        stroke={color}
        strokeLinecap="round"
      />
      <rect
        x="10.3125"
        y="16.5"
        width="8"
        height="6.875"
        transform="rotate(-90 10.3125 16.5)"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M21.7708 19.5V5.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const PaddingVerticalIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <path d="M5.72925 5.5H21.7709" stroke={color} strokeLinecap="round" />
      <rect
        x="9.16675"
        y="9.5"
        width="9.16667"
        height="6"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M5.72925 19.5H21.7709" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const WrapIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.125 6.75L3 9.875M3 9.875L6.125 13M3 9.875H9.5625C10.0139 9.875 10.4609 9.78609 10.878 9.61334C11.295 9.44058 11.674 9.18738 11.9932 8.86818C12.3124 8.54898 12.5656 8.17003 12.7383 7.75297C12.9111 7.33592 13 6.88892 13 6.4375C13 5.98608 12.9111 5.53908 12.7383 5.12202C12.5656 4.70497 12.3124 4.32602 11.9932 4.00682C11.674 3.68762 11.295 3.43441 10.878 3.26166C10.4609 3.08891 10.0139 3 9.5625 3H7.375"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoWrapIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.79169 6.75L3.66669 9.875M3.66669 9.875L6.79169 13M3.66669 9.875H10.2292C10.6806 9.875 11.1276 9.78609 11.5447 9.61334C11.9617 9.44058 12.3407 9.18738 12.6599 8.86818C12.9791 8.54898 13.2323 8.17003 13.405 7.75297C13.5778 7.33592 13.6667 6.88892 13.6667 6.4375C13.6667 5.98608 13.5778 5.53908 13.405 5.12202C13.2323 4.70497 12.9791 4.32602 12.6599 4.00682C12.3407 3.68762 11.9617 3.43441 11.5447 3.26166C11.1276 3.08891 10.6806 3 10.2292 3H8.04169"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66669 13C4.21669 12.45 11.2292 5.4375 14.6667 2"
        stroke={color}
      />
    </svg>
  );
};

export const WrapReverseIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.66673 2L3.00006 4.66667M3.00006 4.66667L5.66673 7.33333M3.00006 4.66667H13.6667M11.0001 14L13.6667 11.3333M13.6667 11.3333L11.0001 8.66667M13.6667 11.3333L3.00006 11.3333"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlignContentFlexStartIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.16669"
        y="4"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 8.16669 4)"
        fill={color}
      />
      <rect
        x="8.16669"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 8.16669 9)"
        fill={color}
      />
      <rect
        x="13.1667"
        y="4"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 13.1667 4)"
        fill={color}
      />
      <rect
        x="13.1667"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 13.1667 9)"
        fill={color}
      />
      <path d="M2.66669 2.5L14.6667 2.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentFlexEndIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.83337"
        y="11.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 11.5)"
        fill={color}
      />
      <rect
        x="8.83337"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 6.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="11.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 11.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 6.5)"
        fill={color}
      />
      <path d="M14.3334 13L2.33337 13" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentStretchIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="9.16669"
        y="13.5"
        width="5.00137"
        height="4"
        rx="1"
        transform="rotate(-90 9.16669 13.5)"
        fill={color}
      />
      <rect
        x="9.16669"
        y="7.50098"
        width="5.00101"
        height="4"
        rx="1"
        transform="rotate(-90 9.16669 7.50098)"
        fill={color}
      />
      <rect
        x="4.16669"
        y="13.5"
        width="5.00137"
        height="4"
        rx="1"
        transform="rotate(-90 4.16669 13.5)"
        fill={color}
      />
      <rect
        x="4.16669"
        y="7.50098"
        width="5.00101"
        height="4"
        rx="1"
        transform="rotate(-90 4.16669 7.50098)"
        fill={color}
      />
      <path d="M14.6667 15L2.66669 15" stroke={color} strokeLinecap="round" />
      <path
        d="M14.6667 1L2.66669 0.999999"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AlignContentCenterIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="7.5"
        y="3"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 7.5 3)"
        fill={color}
      />
      <rect
        x="7.5"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 7.5 9)"
        fill={color}
      />
      <rect
        x="12.5"
        y="3"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 12.5 3)"
        fill={color}
      />
      <rect
        x="12.5"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 12.5 9)"
        fill={color}
      />
      <path d="M2 8L14 8" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentSpaceBetweenIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.5"
        y="13.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.5 13.5)"
        fill={color}
      />
      <rect
        x="8.5"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.5 6.5)"
        fill={color}
      />
      <rect
        x="3.5"
        y="13.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.5 13.5)"
        fill={color}
      />
      <rect
        x="3.5"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.5 6.5)"
        fill={color}
      />
      <path d="M14 15L2 15" stroke={color} strokeLinecap="round" />
      <path d="M14 1L2 0.999999" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentSpaceAroundIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.83337"
        y="12.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 12.5)"
        fill={color}
      />
      <rect
        x="8.83337"
        y="7.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 7.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="12.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 12.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="7.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 7.5)"
        fill={color}
      />
      <path d="M14.3334 15L2.33337 15" stroke={color} strokeLinecap="round" />
      <path
        d="M14.3334 1L2.33337 0.999999"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const JustifySpaceBetweenIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="13"
        y="3"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 13 3)"
        fill={color}
      />
      <rect
        x="13"
        y="10"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 13 10)"
        fill={color}
      />
      <path d="M14 15L2 15" stroke={color} strokeLinecap="round" />
      <path d="M14 1L2 1" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifyFlexEndIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="4"
        y="10.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 10.5)"
        fill={color}
      />
      <rect
        x="4"
        y="6.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 6.5)"
        fill={color}
      />
      <path d="M14 12.5L2 12.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifyFlexStartIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="12"
        y="5.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 5.5)"
        fill={color}
      />
      <rect
        x="12"
        y="9.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 9.5)"
        fill={color}
      />
      <path d="M2 3.5L14 3.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifySpaceEvenlyIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="12"
        width="3"
        height="10"
        rx="1"
        transform="rotate(-90 3 12)"
        fill={color}
      />
      <rect
        x="3"
        y="7"
        width="3"
        height="10"
        rx="1"
        transform="rotate(-90 3 7)"
        fill={color}
      />
      <path d="M2 2L14 2" stroke={color} strokeLinecap="round" />
      <path d="M2 14L14 14" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifyCenterIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="12"
        y="3"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 3)"
        fill={color}
      />
      <rect
        x="12"
        y="10"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 10)"
        fill={color}
      />
      <path d="M2 8L14 8" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsCenterIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="13"
        y="4"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 13 4)"
        fill={color}
      />
      <rect
        x="11"
        y="9"
        width="3"
        height="6"
        rx="1"
        transform="rotate(90 11 9)"
        fill={color}
      />
      <path d="M8 2L8 14" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsEndIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2"
        y="7"
        width="3"
        height="10"
        rx="1"
        transform="rotate(-90 2 7)"
        fill={color}
      />
      <rect
        x="5"
        y="12"
        width="3"
        height="7"
        rx="1"
        transform="rotate(-90 5 12)"
        fill={color}
      />
      <path d="M14 14L14 2" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsStartIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="14"
        y="4"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 14 4)"
        fill={color}
      />
      <rect
        x="11"
        y="9"
        width="3"
        height="7"
        rx="1"
        transform="rotate(90 11 9)"
        fill={color}
      />
      <path d="M2 2L2 14" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsStretchIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="4"
        y="12"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 12)"
        fill={color}
      />
      <rect
        x="4"
        y="7"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 7)"
        fill={color}
      />
      <path d="M2 14L2 2" stroke={color} strokeLinecap="round" />
      <path d="M14 14L14 2" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsBaseline = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 3.5L8.5 6.5L3.5 6.5C2.94772 6.5 2.5 6.05228 2.5 5.5L2.5 4.5C2.5 3.94772 2.94772 3.5 3.5 3.5L8.5 3.5Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M8.5 3.5L8.5 6.5L12.5 6.5C13.0523 6.5 13.5 6.05228 13.5 5.5L13.5 4.5C13.5 3.94771 13.0523 3.5 12.5 3.5L8.5 3.5Z"
        fill={color}
      />
      <path
        d="M8.5 8.5L8.5 11.5L3.5 11.5C2.94772 11.5 2.5 11.0523 2.5 10.5L2.5 9.5C2.5 8.94772 2.94772 8.5 3.5 8.5L8.5 8.5Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M8.5 8.5L8.5 11.5L10.5 11.5C11.0523 11.5 11.5 11.0523 11.5 10.5L11.5 9.5C11.5 8.94771 11.0523 8.5 10.5 8.5L8.5 8.5Z"
        fill={color}
      />
      <path d="M8.5 1.5L8.5 13.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const PlusIcon = ({ color = "currentColor", ...props }) => {
  return (
    <PlusIconLucide
      color={color}
      strokeWidth={"0.5px"}
      width={18}
      height={18}
      {...props}
    />
  );
};

export const MinusIcon = ({ color = "currentColor", ...props }) => {
  return (
    <MinusIconLucide
      color={color}
      strokeWidth={"0.5px"}
      width={18}
      height={18}
      {...props}
    />
  );
};

export const ExpandSettingPadding = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.97909 6.33325V12.6666" stroke={color} strokeLinecap="round" />
      <path d="M17.0208 6.33325V12.6666" stroke={color} strokeLinecap="round" />
      <path d="M12.6667 16.625H6.33341" stroke={color} strokeLinecap="round" />
      <path
        d="M12.6667 2.375L6.33341 2.375"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MaximizeIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6666 5.33337L13.3333 8.00004L10.6666 10.6667"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66663 8L13.3333 8"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33329 5.33337L2.66663 8.00004L5.33329 10.6667"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SpacingIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" y="4" width="4" height="8" rx="1" fill={color} />
      <path d="M2 14L2 2" stroke={color} strokeLinecap="round" />
      <path d="M14 14L14 2" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const FliPIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8H14"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 3.66659L7.99992 6.33325L10.6666 3.66659"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 12.3333L7.99992 9.66659L5.33325 12.3333"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RevertIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.21199 7.48859C3.14478 7.55572 3.09147 7.63545 3.0551 7.7232C3.01872 7.81095 3 7.90501 3 8C3 8.09499 3.01872 8.18905 3.0551 8.2768C3.09147 8.36455 3.14478 8.44428 3.21199 8.51141L5.48859 10.788C5.55572 10.8552 5.63545 10.9085 5.7232 10.9449C5.81095 10.9813 5.90501 11 6 11C6.09499 11 6.18905 10.9813 6.2768 10.9449C6.36455 10.9085 6.44428 10.8552 6.51141 10.788L8.78801 8.51141C8.85522 8.44428 8.90853 8.36455 8.9449 8.2768C8.98128 8.18905 9 8.09499 9 8C9 7.90501 8.98128 7.81095 8.9449 7.7232C8.90853 7.63545 8.85522 7.55572 8.78801 7.48859L6.51141 5.21199C6.44428 5.14478 6.36455 5.09147 6.2768 5.0551C6.18905 5.01872 6.09499 5 6 5C5.90501 5 5.81095 5.01872 5.7232 5.0551C5.63545 5.09147 5.55572 5.14478 5.48859 5.21199L3.21199 7.48859Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.58374 4.22791L9.39219 4.39231L9.22778 2.58386"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4L5.4267 1.5733C5.57874 1.42126 5.78495 1.33585 5.99996 1.33585C6.21498 1.33585 6.42119 1.42126 6.57323 1.5733L9 4.00007"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BorderWithIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.33337 4L14.6667 4" stroke={color} strokeLinecap="round" />
      <path
        d="M1.33337 7L14.6667 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.33337 11L14.6667 11"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SolidBarIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="2"
      viewBox="0 0 16 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.33337 1L14.6667 1" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const LineHeightIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.66667L10 8.66667M4.66667 11.3333L7.51447 5.06816C7.66872 4.72882 7.74584 4.55915 7.85271 4.50651C7.94558 4.46077 8.05442 4.46077 8.14729 4.50651C8.25416 4.55915 8.33128 4.72882 8.48553 5.06816L11.3333 11.3333M14 2V14M2 2L2 14"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LetterSpacingIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.66667H10M4.66667 11.3333L7.51447 5.06816C7.66872 4.72882 7.74584 4.55915 7.85271 4.50651C7.94558 4.46077 8.05442 4.46077 8.14729 4.50651C8.25416 4.55915 8.33128 4.72882 8.48553 5.06816L11.3333 11.3333M14 14H2M14 2H2"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StrikethroughIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8C3 9.10457 3.89543 10 5 10H7C8.10457 10 9 9.10457 9 8C9 6.89543 8.10457 6 7 6M9 4C9 2.89543 8.10457 2 7 2H5C3.89543 2 3 2.89543 3 4M1.5 6H10.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlignLeftIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8" y="4" width="4" height="8" rx="1" fill={color} />
      <path d="M4 14L4 2" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const SquareDashedIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 3a2 2 0 0 0-2 2" />
      <path d="M19 3a2 2 0 0 1 2 2" />
      <path d="M21 19a2 2 0 0 1-2 2" />
      <path d="M5 21a2 2 0 0 1-2-2" />
      <path d="M9 3h1" />
      <path d="M9 21h1" />
      <path d="M14 3h1" />
      <path d="M14 21h1" />
      <path d="M3 9v1" />
      <path d="M21 9v1" />
      <path d="M3 14v1" />
      <path d="M21 14v1" />
    </svg>
  );
};

export const PlanOfActionIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 12H3" />
      <path d="M16 18H3" />
      <path d="M16 6H3" />
      <path d="M21 12h.01" />
      <path d="M21 18h.01" />
      <path d="M21 6h.01" />
    </svg>
  );
};

export const OverlineIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.61292 4.60081V7.9879C3.61292 8.88622 3.96977 9.74774 4.60498 10.3829C5.24018 11.0181 6.1017 11.375 7.00002 11.375C7.89833 11.375 8.75985 11.0181 9.39506 10.3829C10.0303 9.74774 10.3871 8.88622 10.3871 7.9879V4.60081M2.48389 2.625H11.5161"
        stroke="currentColor"
        strokeWidth="0.967742"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
